import App from "@/views/App.vue";

export default [
  {
    path: "/configuracoes",
    name: "settings",
    component: App,
    children: [
      {
        path: "/configuracoes/postagem/:id",
        name: "settingsMetricsPost",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/MetricsSelectedPost.vue"
          ),
        meta: {
          displayName: "displayName.metricsPost",
          requiresAuth: true,
        },
      },
      {
        path: "/configuracoes/comunidade/:id",
        name: "settingsCommunity",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Community.vue"),
        meta: {
          displayName: "displayName.communityHome",
          requiresAuth: true,
        },
      },
      {
        path: "/configuracoes/cota-comunidade/:id",
        name: "settingsQuotaCommunity",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/QuotaCommunity.vue"),
        meta: {
          displayName: "displayName.communityQuota",
          requiresAuth: true,
        },
      },
      {
        path: "/configuracoes/anuncios/:id?",
        name: "settingsAdverts",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Adverts.vue"),
        meta: {
          displayName: "displayName.advertsApproved",
          requiresAuth: true,
        },
      },
      {
        path: "/configuracoes/fixar-tag",
        name: "settingsNewFixTag",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/NewFixTag.vue"),
        meta: {
          displayName: "displayName.fixedTag",
          requiresAuth: true,
        },
      },
      {
        path: "/configuracoes/anuncios/aprovados",
        name: "settingsAdvertsApproved",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/AdvertsApproved.vue"
          ),
        meta: {
          displayName: "displayName.advertsApproved",
          requiresAuth: true,
        },
      },
      {
        path: "/configuracoes/anuncios/removidos",
        name: "settingsAdvertsDeleted",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/AdvertsDeleted.vue"),
        meta: {
          displayName: "displayName.advertsDeleted",
          requiresAuth: true,
        },
      },
      {
        path: "/configuracoes/anuncios/desaprovados/:id?",
        name: "settingsAdvertsDisapproved",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/AdvertsDisapproved.vue"
          ),
        meta: {
          displayName: "displayName.advertsDisapproved",
          requiresAuth: true,
        },
      },
      {
        path: "/configuracoes/anuncios/pendentes",
        name: "settingsAdvertsPending",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/AdvertsPending.vue"),
        meta: {
          displayName: "displayName.advertsPending",
          requiresAuth: true,
        },
      },
      {
        path: "/configuracoes/anuncios/rejeitados",
        name: "settingsAdvertsRejected",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/AdvertsRejected.vue"
          ),
        meta: {
          displayName: "displayName.advertsRejected",
          requiresAuth: true,
        },
      },
      {
        path: "/configuracoes/lounges",
        name: "settingsCommunities",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Communities.vue"),
        meta: {
          displayName: "displayName.lounges",
          requiresAuth: true,
        },
      },
      {
        path: "/configuracoes/denuncias",
        name: "settingsDenunciation",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Denunciations.vue"),
        meta: {
          displayName: "displayName.denunciations",
          requiresAuth: true,
        },
      },
      {
        path: "/configuracoes/posts-fixados",
        name: "settingsFixedPosts",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/FixedPosts.vue"),
        meta: {
          displayName: "displayName.fixedPosts",
          requiresAuth: true,
        },
      },
      {
        path: "/configuracoes/inativacoes",
        name: "settingsInactivates",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Inactivates.vue"),
        meta: {
          displayName: "displayName.inactivations",
          requiresAuth: true,
        },
      },
      {
        path: "/configuracoes/interesses",
        name: "settingsInterests",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Interests.vue"),
        meta: {
          displayName: "displayName.interests",
          requiresAuth: true,
        },
      },
      {
        path: "/configuracoes/metricas/empresa",
        name: "settingsMetricsCompany",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/MetricsCompany.vue"),
        meta: {
          displayName: "displayName.metricsCompany",
          requiresAuth: true,
        },
      },
      {
        path: "/configuracoes/metricas/exclusive",
        name: "settingsMetricsExclusive",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/MetricsExclusive.vue"
          ),
        meta: {
          displayName: "displayName.metricsExclusive",
          requiresAuth: true,
        },
      },
      {
        path: "/configuracoes/metricas/4network",
        name: "settingsMetricsNetwork",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/MetricsNetwork.vue"),
        meta: {
          displayName: "displayName.metricsNetwork",
          requiresAuth: true,
        },
      },
      {
        path: "/configuracoes/metricas/posts",
        name: "settingsMetricsPosts",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/MetricsPost.vue"),
        meta: {
          displayName: "displayName.metricsPost",
          requiresAuth: true,
        },
      },
      {
        path: "/configuracoes/metricas/posts-agendados",
        name: "settingsMetricsSchedulePost",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/MetricsSchedulePost.vue"
          ),
        meta: {
          displayName: "displayName.metricsSchedulePost",
          requiresAuth: true,
        },
      },
      {
        path: "/configuracoes/usuarios/pessoas",
        name: "settingsUsersClevel",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/UsersClevel.vue"),
        meta: {
          displayName: "displayName.usersPerson",
          requiresAuth: true,
          rule: "USER_PROFILE_LIST1",
        },
      },
      {
        path: "/configuracoes/usuarios/empresas",
        name: "settingsUsersMarketing",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/UsersMarketing.vue"),
        meta: {
          displayName: "displayName.usersCompany",
          requiresAuth: true,
        },
      },
      {
        path: "/configuracoes/fixar-tag/:id",
        name: "settingsEditFixTag",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/EditFixTag.vue"),
        meta: {
          displayName: "displayName.editFixedTag",
          requiresAuth: true,
        },
      },
      {
        path: "/configuracoes/permissoes/:id",
        name: "settingsPermissions",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Permissions.vue"),
        meta: {
          displayName: "displayName.permissions",
          requiresAuth: true,
        },
      },
      {
        path: "/configuracoes/postagem-colab/:id",
        name: "settingsMetricsColab",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/MetricsSelectedColab.vue"
          ),
        meta: {
          displayName: "displayName.metricsColab",
          requiresAuth: true,
        },
      },
      {
        path: "/configuracoes/usuarios-permissoes",
        name: "settingsUsersPermission",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/UsersPermission.vue"
          ),
        meta: {
          displayName: "displayName.permissionsUsers",
          requiresAuth: true,
        },
      },
      {
        path: "/configuracoes/transmissoes",
        name: "settingsMetricsTransmission",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/MetricsTransmission.vue"
          ),
        meta: {
          displayName: "displayName.metricsTransmission",
          requiresAuth: true,
        },
      },
      {
        path: "/configuracoes/empresas-fixadas",
        name: "settingsFixedCompanies",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/FixedCompanies.vue"),
        meta: {
          displayName: "displayName.fixedCompanies",
          requiresAuth: true,
        },
      },
      {
        path: "/configuracoes/debates",
        name: "settingsDebates",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Debates.vue"),
        meta: {
          displayName: "displayName.debates",
          requiresAuth: true,
        },
      },
      {
        path: "/configuracoes/metricas/geral",
        name: "settingsMetricsGeneral",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/MetricsGeneral.vue"),
        meta: {
          displayName: "displayName.metricsGeneral",
          requiresAuth: true,
        },
      },
      {
        path: "/configuracoes/anuncios/aguardando-aprovacao",
        name: "settingsAdvertsWaiting",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/AdvertsWaiting.vue"),
        meta: {
          displayName: "displayName.advertsWaiting",
          requiresAuth: true,
        },
      },
      {
        path: "/configuracoes/metricas/meus-anuncios",
        name: "settingsMetricsMarketing",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/MetricsMarketing.vue"
          ),
        meta: {
          displayName: "displayName.metricsMarketing",
          requiresAuth: true,
        },
      },
      {
        path: "/configuracoes/pesquisas",
        name: "settingsSurveyItems",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/SurveyItems.vue"),
        meta: {
          displayName: "displayName.surveys",
          requiresAuth: true,
        },
      },
      {
        path: "/configuracoes/pesquisas/:id",
        name: "settingsSurveyMetrics",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/SurveyMetrics.vue"),
        meta: {
          displayName: "displayName.surveyMetrics",
          requiresAuth: true,
        },
      },
      {
        path: "/configuracoes/logs",
        name: "settingsLogsItems",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/LogsItems.vue"),
        meta: {
          displayName: "displayName.logs",
          requiresAuth: true,
        },
      },
      {
        path: "/configuracoes/beneficios",
        name: "settingsProductItems",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/ProductItems.vue"),
        meta: {
          displayName: "displayName.products",
          requiresAuth: true,
        },
      },
      {
        path: "/configuracoes/beneficios/:id",
        name: "settingsProductMetrics",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/ProductMetrics.vue"),
        meta: {
          displayName: "displayName.productMetrics",
          requiresAuth: true,
        },
      },
    ],
  },
];
